/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LanguageLocaleDto } from '../../models/language-locale-dto';

export interface ApiLanguagesLanguageLocalesIdGet$Params {
  id: string;
}

export function apiLanguagesLanguageLocalesIdGet(http: HttpClient, rootUrl: string, params: ApiLanguagesLanguageLocalesIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<LanguageLocaleDto>> {
  const rb = new RequestBuilder(rootUrl, apiLanguagesLanguageLocalesIdGet.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LanguageLocaleDto>;
    })
  );
}

apiLanguagesLanguageLocalesIdGet.PATH = '/api/Languages/language-locales/{id}';
